module.exports = __webpack_public_path__ + "static/media/google-maps.3b26eaf2.svg";